import React from "react";
import { Redirect, Link, useHistory } from 'react-router-dom';
import { Routes } from '../Core/Constants';
import { UserProvider } from './../Providers/UserProvider';
import { Storage } from './../Core/Storage';
import { ReturnRequestProvider } from './../Providers/ReturnRequestProvider';

function WithdrawalCell({ order }) {
	const T = window.Texts.returnRequest;
	const history = useHistory();
	const [loading, setLoading] = React.useState(false);
	const state = order.withdrawalButtonState;
	const handleClick = () => {
		setLoading(true);
		ReturnRequestProvider.getAccessForOrder(
			order.id,
			(data) => history.push(Routes.ReturnRequest + '?token=' + data.accessToken),
			() => setLoading(false)
		);
	};

	if (!state) return null;

	if (state === 'HasRequest') {
		return <>
			<span style={{ fontSize: '12px', color: '#888', marginRight: '8px' }}>{T.requestStatus}: {T['status' + order.returnRequestStatus]}</span>
			<button onClick={handleClick} disabled={loading} className="btn btn50" style={{ fontSize: '12px' }}>{T.withdrawalBtn}</button>
		</>;
	}
	if (state === 'WithinPeriod') {
		return <button onClick={handleClick} disabled={loading} className="btn btn50" style={{ fontSize: '12px' }}>{T.withdrawalBtn}</button>;
	}
	if (state === 'CanCancel') {
		return <span style={{ fontSize: '12px', color: '#888' }}>{T.withdrawalCanCancelText}</span>;
	}
	if (state === 'NotDelivered') {
		return <button onClick={handleClick} disabled={loading} className="btn btn50" style={{ fontSize: '12px' }}>{T.withdrawalBtn}</button>;
	}
	if (state === 'AfterPeriod') {
		return <span style={{ fontSize: '12px', color: '#888' }}>{T.withdrawalAfterPeriodText}</span>;
	}
	return null;
}

export default class Orders extends React.Component {
	state = {
	    orders:[]
	}
    componentDidMount = () => {
		UserProvider.getOrders((data) => {
			window.gtm.loadAccount("orders");
			this.setState({ orders: data });

        })
	}
	
    render() {
        if (!Storage.instance().isAuthorized())
            return (
                <Redirect to={Routes.Login} />);

        let orders = this.state.orders;
		var T = window.Texts.orders;
		if (this.state.success)
			return <Redirect to={Routes.SucessRegistration} />;

		return (
            <div className="orders-page">
                <div className="cover">
                    <div className="headline">
                        <h1>{T.ordersTitle}</h1>
                    </div>
                    {orders.length == 0 ?
                        <div className="orders">{T.empty}</div> :
                        <div className="orders">
                            <ul className="order order-headline">
                                <li className="number">
                                    <p>
                                        <span>{T.catNum}</span>
                                    </p>
                                </li>
                                <li className="date">
                                    <p>
                                        <span>{T.placedOn}</span>
                                    </p>
                                </li>
                                <li className="state">
                                    <p>
                                        <span>{T.state}</span>
                                    </p>
                                </li>
                                <li className="price">
                                    <p>
                                        <span>{T.price}</span>
                                    </p>
                                </li>
                                <li className="withdrawal"></li>
                            </ul>
                            {orders.map((order) => {
                               return <ul className="order order-line" key={order + order.id}>
                                    <li className="number">
                                        <p>
                                            <span>{T.catNum + ':'} </span>
                                            <Link to={Routes.Order + '/' + order.id}>{order.invoiceCode}</Link>
                                        </p>
                                    </li>
                                    <li className="date">
                                        <p>
                                            <span>{T.placedOn + ':'}  </span>
                                            {order.created}
                                        </p>
                                    </li>
                                    <li className="state">
                                        <p><span>Stav: </span>
                                            {order.displayState}
                                        </p>
                                    </li>
                                    <li className="price">
                                        <p>
                                            <span>{T.price + ':'}</span>
                                            {order.priceTable.displayTotalPriceInclVat} <small>( {order.priceTable.displayTotalPriceExclVat} bez DPH)</small>
                                        </p>
                                    </li>
                                    <li className="withdrawal">
                                        <WithdrawalCell order={order} />
                                    </li>
                                </ul>
                            })}
                        </div>}
    </div> 
</div>
		);
	}
}

